<template>
    <div>
            <v-layout wrap >
                <v-flex xs12 >
                    <span class="title">Liste des demandes de congés de l'année en cours</span>
                    <v-divider class="mb-2"></v-divider>
                </v-flex>


                <v-flex xs12 class="text-xs-right">
                    <v-tooltip bottom>
                        <v-btn class="elevation-3" slot="activator" @click="loadListeAbsence()" dark icon flat color="primary">
                            <v-icon>cached</v-icon>
                        </v-btn>
                        actualiser la liste
                    </v-tooltip>
                </v-flex>
        <el-form :inline="true" :model="formTri" class="demo-form-inline">

            <el-form-item label="Date">
                <el-date-picker
                        format="MM-yyyy"
                        v-model="formTri.dateDebut"
                        placeholder="Date de debut"
                        type="month"
                >
                </el-date-picker>
                 <el-date-picker
                        format="MM-yyyy"
                        v-model="formTri.dateFin"
                        placeholder="Date de fin"
                        type="month"
                        @change="verifDate"
                >
                </el-date-picker>
            </el-form-item>




            <el-form-item label="">
                <v-tooltip bottom>
                    <v-btn @click="rechercheUser()" slot="activator" class="white--text" color="blue" fab small :disabled="desactiveBout">
                        <v-icon>search</v-icon>
                    </v-btn>Effectuer une recherche
                </v-tooltip>
            </el-form-item>
        </el-form>




                <v-flex xs12>
                    <Loading :value="loadingAbsence" ></Loading>
                    <v-alert class="elevation-1 subheading mb-1" color="warning" :value="true" icon="priority_high" outline>
                        Durée: Affiche le Total des jours sans les weekends et les jours fériés.
                    </v-alert>
                    <data-tables :data="listeAbsence" style="width:100%">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <v-layout wrap class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4">
                                    <v-flex xs12>
                                        <v-layout row>
                                            <v-flex xs6 mr-2>
                                                <span class="title">Validateur demande d'absence</span>
                                                <v-divider class="mb-2"></v-divider>
                                                <el-table
                                                        :data="props.row.validationDmd"
                                                        stripe
                                                        style="width: 100%">
                                                    <el-table-column
                                                            prop="responsable"
                                                            label="Responsable"
                                                            width="180">
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="statut"
                                                            label="Statut"
                                                            width="200">
                                                        <template slot-scope="scope">
                                                            <span class="cyan--text body-2">{{scope.row.statut}}</span>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="dateValidation"
                                                            label="date validation">
                                                    </el-table-column>

                                                </el-table>
                                            </v-flex>

                                            <v-flex xs4>
                                                <div class="grid-content">
                                                    <p class="title">Description du demandeur</p>
                                                    <v-divider></v-divider>
                                                </div>
                                                <div class="grid-content">
                                                    <el-input
                                                            type="textarea"
                                                            :rows="4"
                                                            :disabled="true"
                                                            readonly="true"
                                                            placeholder="Description"
                                                            v-model="props.row.description">
                                                    </el-input>
                                                </div>
                                            </v-flex>

                                            <v-flex xs2 mr-2>
                                                <div class="grid-content">
                                                    <p class="title">Fichiers</p>
                                                    <v-divider></v-divider>
                                                </div>
                                                <v-divider class="mb-2"></v-divider>
                                                <div class="grid-content">
                                                        <v-tooltip bottom>
                                                            <v-avatar
                                                                    slot="activator"
                                                                    v-for="(image, imageIndex) in props.row.imagesAbs"
                                                                    :key="imageIndex"
                                                                    @click="showDiapo(props.row.imagesAbs,imageIndex)"
                                                                    :style="{ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}"
                                                                    :tile=true
                                                                    :size="50"
                                                                    color="grey lighten-4"
                                                                    class="mb-1 mr-1 elevation-3"
                                                            >
                                                                <img :src="image" alt="avatar">
                                                            </v-avatar>
                                                            Cliquez pour agrandir
                                                        </v-tooltip>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </template>
                        </el-table-column>
                        <el-table-column  prop="idAbsence" label="ID-DEMANDE" align="left" > </el-table-column>
                        <el-table-column   prop="typeConge" label="TYPE CONGE" align="left"></el-table-column>
                        <el-table-column   prop="demandeur" label="DEMANDEUR" align="left"></el-table-column>
                        <el-table-column   prop="service" label="SERVICE" align="left"></el-table-column>
                        <el-table-column   prop="poste" label="POSTE" align="left"></el-table-column>
                        <el-table-column   prop="dateDbt" label="DATE DEBUT" align="left"></el-table-column>
                        <el-table-column  prop="dateFin" label="DATE FIN"  align="left"></el-table-column>
                        <el-table-column  prop="duree" label="DUREE"  align="left"></el-table-column>
                        <el-table-column  prop="heureDabsce" label="TOTAL HEURE ABSENCE"  align="left"></el-table-column>
                        <el-table-column   prop="status" label="STATUT" align="left">
                            <template slot-scope="scope" >
                                <el-tag   v-if="scope.row.status == 'En cours de traitement'" >{{scope.row.status}}</el-tag>
                                <el-tag   v-else-if="scope.row.status == 'En Attente de validation par DG'"  type="warning">{{scope.row.status}}</el-tag>
                                <el-tag   v-else-if="scope.row.status == 'Refusé par la DRH'"  type="danger">{{scope.row.status}}</el-tag>
                                <el-tag   v-else-if="scope.row.status == 'Validée par DG'"  type="success">{{scope.row.status}}</el-tag>
                                <el-tag   v-else-if="scope.row.status == 'Refusé le DG'"  type="danger">{{scope.row.status}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column  prop="Action" label="Action" align="center"  width="200" fixed="right">
                            <template slot-scope="scope" >
                               <v-tooltip bottom v-if="scope.row.status =='En cours de traitement' || scope.row.status =='En Attente de validation par DG'">
                                        <v-btn @click="editDemande(scope.row)" slot="activator" fab dark small color="primary">
                                            <v-icon dark>edit</v-icon>
                                        </v-btn>
                                        Modifier la demande
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="scope.row.status =='En cours de traitement' ">
                                        <v-btn @click="idAbsenceSelect = scope.row.idAbsence; dialogValide = true;deduireVacance= false;" v-if="statutDemande == 0" slot="activator" fab dark small color="green">
                                            <v-icon dark>done</v-icon>
                                        </v-btn>
                                        Approuver la demande
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="scope.row.status =='En Attente de validation par DG'" >
                                        <v-btn @click="showValideAbs(scope.row)" v-if="statutDemande == 1"  slot="activator" fab dark small color="green">
                                            <v-icon dark>done_all</v-icon>
                                        </v-btn>
                                        Valider la demande
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="scope.row.status =='En cours de traitement' || scope.row.status =='En Attente de validation par DG'" >
                                        <v-btn  @click="idAbsenceSelect = scope.row.idAbsence; dialogRefus = true"   slot="activator" fab dark small color="red">
                                            <v-icon dark>close</v-icon>
                                        </v-btn>
                                        Refuser la demande
                                    </v-tooltip>
                            </template>
                        </el-table-column>
                    </data-tables>
                </v-flex>
            </v-layout>

        <!--DIALOG REFUS DEMANDE-->
        <v-dialog
                v-model="dialogRefus"
                max-width="550"
        >
            <v-card>
                <v-card-title class="headline">

                    <el-alert
                            title="Voulez-vous refuser la demande selectionnée ?"
                            type="warning"
                            :closable="false"
                            show-icon>
                    </el-alert>
                </v-card-title>
                <v-card-text>
                        <el-input :rows="4" placeholder="Motif du refus" type="textarea" v-model="descRefus"></el-input>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="dialogRefus = false"
                    >
                        Annuler
                    </v-btn>

                    <v-btn
                            color="red darken-1"
                            flat="flat"
                            @click="submitDemande(0,idAbsenceSelect)"
                    >
                        Refuser
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--DIALOG VALIDE DEMANDE-->
        <v-dialog
                v-model="dialogValide"
                max-width="650"
        >
            <v-card>
                <v-card-title class="headline">
                    <span class="title mb-2">Valider la demande d'absence</span>

                    <el-alert
                            v-if="statutDemande == 0 || typeIdAbsenceSelect == 'VACANCE'"
                            title="Voulez-vous valider la demande selectionnée ?"
                            type="warning"
                            :closable="false"
                            show-icon>
                    </el-alert>


                    <el-alert
                            v-if="statutDemande == 1 && typeIdAbsenceSelect != 'VACANCE'"
                            title="Avertissement"
                            type="warning"
                            :closable="false"
                            description="Si l'option déduire est selectionée la période d'absence sera déduite des jours de congés annuels"
                            show-icon>
                    </el-alert>

                    <el-form v-if="statutDemande == 1 && typeIdAbsenceSelect != 'VACANCE'" label-width="130px" label-position="top" style="width:100%" >
                        <el-form-item label="Déduire des jours des congés annuels">
                            <el-select v-model="deduireVacance" placeholder="Déduire la période d'absence des congés annuels ?">
                                <el-option v-for="(item, index) in listeDeduction" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <span class="display-1 blue--text">&nbsp {{nbJoursVacance}}/30</span> Jrs rest/Total
                            &nbsp
                            <span class="display-1 red--text">&nbsp {{dureeAbs}}</span> Jrs Absence dmd
                        </el-form-item>
                        <el-form-item label="Commentaire" v-if="deduireVacance == true">
                            <el-input type="textarea" rows="5" v-model="descRefus"></el-input>
                        </el-form-item>
                    </el-form>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="grey darken-1"
                            flat="flat"
                            @click="dialogValide = false"
                    >
                        Annuler
                    </v-btn>
                    <v-btn

                            color="green darken-1"
                            class="white--text"
                            @click="submitDemande(1,idAbsenceSelect)"
                            :disabled="deduireVacance == true && descRefus == ''"
                    >
                        Valider
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- MODAL MODIF DEMANDE USER -->
    <v-dialog
      persistent
      v-model="dialogModifDemande"
      :overlay="true"
      max-width="50%"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Modifier la demande de {{nomDemandeur}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogModifDemande = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-form ref="formAbsence"  :model="formDmdAbsence" class="demo-form-inline">
            <el-row type="flex" :gutter="20" justify="center">
                <el-col :span="14">
                    <div class="block">
                        <el-form-item label="Période de congé">
                            <el-date-picker
                              style="width: 100%"
                              v-model="formDmdAbsence.datedbtFin"
                              format="dd-MM-yyyy HH:mm"
                              value-format="yyyy-MM-dd HH:mm"
                              type="datetimerange"
                              range-separator="au"
                              start-placeholder="Début date"
                              end-placeholder="Fin date"
                            ></el-date-picker>
                        </el-form-item>
                     </div>
                </el-col>
                <el-col :span="10">
                    <div>
                        <el-form-item label="Type de congé">
                            <el-select v-model="formDmdAbsence.idTypeConge" placeholder="Type de congé">
                                <el-option v-for="(item,index) in listeTypeConge" :key=index :label="item.label" :value="item.value" ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>

            <el-row type="flex" :gutter="20"  justify="end">
                <v-tooltip top>
                    <v-btn
                            slot="activator"
                            class="white--text"
                            color="orange"
                            @click.stop="dialogModifDemande = false"
                    >
                        Annuler
                        <v-icon right>remove_circle</v-icon>
                    </v-btn>
                    Annuler la modificatioon
                </v-tooltip>
              <v-tooltip top>
                <v-btn
                        slot="activator"
                        class="white--text"
                        color="green"
                        @click="submitModDemande()"
                >

                    Enregistrer
                    <v-icon right>save</v-icon>
                </v-btn>
                enregistrer la modificatioon
            </v-tooltip>
            </el-row>
        </el-form>
        </v-card-text>
      </v-card>
    </v-dialog>


        <CoolLightBox
                :items="items"
                :index="index"
                @close="index = null"
        >

        </CoolLightBox>
    </div>
</template>

<script>
    import Loading from '@/components/Loading';

    export default {
        props:{
            statutDemande: {
                type: Number,
                default: 0 //0=> En cours de traitement, //1=>En Attente de validation par DG
            }
        },
        components: {Loading},
        name: "listeDemande",
        data(){
            return {
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

                loadingAbsence: false,
                listeAbsence: [],
                listeTypeConge: [],
                idAbsence:'',
                formDmdAbsence:{
                  datedbtFin:'',
                  idTypeConge:''
                },
                nomDemandeur: '',
                idDemandeur:'',

                dialogRefus: false,
                dialogValide: false,
                dialogModifDemande: false,
                idAbsenceSelect: null,
                descRefus: "",
                desactiveBout:false,

                formTri: {},
                deduireVacance: false,
                typeIdAbsenceSelect: null,
                nbJoursVacance: 0,
                dureeAbs:0,
                items: [],
                index: null,
                listeDeduction:[
                    {
                        label: "Déduire",
                        value: true
                    },
                    {
                        label: "Ne pas déduire",
                        value: false
                    },

                ],

            }
        },
        methods:{
            verifDate(){
                 if(this.formTri.dateFin.getTime() <= this.formTri.dateDebut.getTime())
                {
                    this.formTri.dateFin = null;
                    // this.formTri.dateDebut = null;

                    this.$alert('La fin doit être strictement superieur à la date de debut', 'Validation champs date', {
                        confirmButtonText: 'OK',
                    });
                }
            },
             loadTypeConge(){
                let url = this.domaine + 'rh/listeTypeConge';
                this.$http.get(url).then(resData => {
                        this.listeTypeConge = resData.body.listeAbsences;

                    },
                    error =>{
                        this.loading = false;
                        this.$message.error("Echec lors du chargement de al liste des type de congé")
                    })
            },
            rechercheUser(){
                this.loading = true;
                this.listeEmployes = [];
                let url = this.domaine + 'rh/recherche/listeTotalAbsence';
                let tabDbt = new Intl.DateTimeFormat('en-GB').format(this.formTri.dateDebut).split("/")
                let tabDFin = new Intl.DateTimeFormat('en-GB').format(this.formTri.dateFin).split("/")
                    let data = {
                        dateDbt:  tabDbt[2]+"-"+tabDbt[1]+"-"+tabDbt[0],
                        dateFin:  tabDFin[2]+"-"+tabDFin[1]+"-"+tabDFin[0],
                    }

                this.$http.get(url,{params:data}).then(response => {
                    this.listeAbsence = response.body.listeAbsences
                    this.loading = false
                }, err=>{
                    this.loading = false
                    this.$message.error("Chargement de la liste de recherche des employes, verifier votre connexion");
                })


            },
            showDiapo(images, ind){
                this.items = images
                this.index = ind;
            },
            showValideAbs(item){
                this.idAbsenceSelect = item.idAbsence;
                this.dialogValide = true;
                this.deduireVacance= false;
                this.typeIdAbsenceSelect = item.typeConge,
                this.nbJoursVacance = item.nbJoursVacance;
                this.dureeAbs = item.duree
            },
            editDemande(item){
              console.log('editDemande',item)
              this.dialogModifDemande = true
              this.nomDemandeur = item.demandeur
              this.idAbsence = item.idAbsence
              this.idDemandeur = item.idDemandeur
              // this.formDmdAbsence.datedbtFin = item.
              this.formDmdAbsence.idTypeConge = item.typeConge
            },
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },

            loadListeAbsence()
            {
                this.loadingAbsence = true;
                let url = this.domaine + 'rh/listeTotalAbsence'
                this.$http.get(url).then(response => {
                        //this.listeAbsence = response.body.listeAbsences;
                        this.listeAbsence = response.body.listeAbsences.filter(abs =>{
                            return (abs.idStatus == this.statutDemande)
                        })
                        this.loadingAbsence = false
                    },
                    error =>{
                        this.loadingAbsence = false
                        this.$message.error("Echec lors du chargement de la liste des demandes absences")
                    })
            },
            submitModDemande(){
              console.log('this.formDmdAbsence',this.formDmdAbsence)
                this.loadingAbsence = true;
                let url = this.domaine + 'rh/modif/absence/'+this.idAbsence
                let data = new FormData();
                data.append("dataForm", JSON.stringify(this.formDmdAbsence))
                data.append("userId", this.user.id)
                this.$http.post(url,data).then(response => {
                        this.dialogModifDemande = false
                        this.loadingAbsence = false;
                        if(response.body.code == 0){
                            this.$alert(response.body.message, "Modification demande d'absence", {
                                confirmButtonText: 'OK',
                            });
                            return;
                        }

                         if(response.body.code == 1){
                            this.$alert(response.body.message, "Modification demande d'absence", {
                                confirmButtonText: 'OK',
                            });
                        }
                          this.formDmdAbsence.datedbtFin = ''
                          this.formDmdAbsence.idTypeConge = ''
                          this.idAbsence =''
                          this.idDemandeur=''
                          this.loadListeAbsence()
                          this.resetForm('formAbsence')
                          this.closeForm();
                    },
                    error =>{
                        this.loadingAbsence = false;
                        this.$message.error("Echec lors de l'enregistrement de la demande")
                    })
            },
            submitDemande(decision,idDemandeAbsence){
                if(this.nbJoursVacance < this.dureeAbs &&  this.deduireVacance == true ){
                    this.$message.error("Le nombre de jour restant est inférieur a la durée d'absence demandée")
                    return;
                }
                this.loadingAbsence = true;
                this.dialogRefus = false;
                let url = this.domaine + 'rh/validationDemande/'+this.user.id
                let data = new FormData();
                data.append("decision", decision)
                if(this.statutDemande == 0)
                {
                data.append("etatdecision", 0)

                }else if (this.statutDemande == 1){
                data.append("etatdecision", 1)

                }
                data.append("idAbsence",idDemandeAbsence)
                data.append("description",this.descRefus)
                data.append("deduireVacance",this.deduireVacance)

                this.$http.post(url, data).then(response => {
                        this.loadingAbsence = false;
                        this.dialogRefus = false,
                        this.dialogValide = false,
                        this.loadListeAbsence()
                        this.successNotif(response.body.message)

                    },
                    error =>{
                        this.loadingAbsence = false
                        this.$message.error("Echec lors de la validation de demande d'absences")
                    })
            },
               closeForm(){
                this.$emit("close");
            },
        },
        mounted(){
            this.loadListeAbsence()
            this.loadTypeConge()
        }
    }

</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/resourceHumaine/liste_demande.vue